
import { Options, Vue } from 'vue-class-component'
import Udvalg from '@/components/Frontend/Udvalg/index.vue'

@Options({
  components: {
    Udvalg
  }
})
export default class UdvalgView extends Vue {}
